export default __webpack_public_path__ + "static/media/wallet-icon.6d2188f0.svg";